import classNames from "classnames";
import React from "react";

interface DiscountBadgeProps {
  percentage: number;
  className?: string;
  mode?: "dark" | "light";
}

interface OptionsBadgeProps {
  options: number;
  className?: string;
}

const DiscountBadge: React.FC<DiscountBadgeProps> = ({ percentage, className, mode = "light" }) => {
  return (
    <div
      className={classNames(
        "rounded-[30px] px-2 py-0.5 text-xxxs  font-semibold flex whitespace-nowrap mb-0.5",
        className,
        {
          "bg-discount-badge text-white": mode === "dark",
          "bg-discount-badge bg-opacity-[0.1] text-discount-badge ": mode === "light",
        }
      )}
    >
      {percentage}% OFF
    </div>
  );
};

const DiscountBadgeImage: React.FC<DiscountBadgeProps> = ({ percentage, className, mode = "light" }) => {
  return (
    <div
      className={classNames(
        "rounded-[5px] px-2 py-1 text-xxs font-semibold flex whitespace-nowrap mb-0.5 items-center",
        className,
        {
          "bg-discount-badge text-white": mode === "dark",
          "bg-discount-badge bg-opacity-[0.1] text-discount-badge ": mode === "light",
        }
      )}
    >
      {percentage}% OFF
    </div>
  );
};

const OptionsBadge: React.FC<OptionsBadgeProps> = ({ options, className }) => {
  return (
    <div
      className={classNames(
        "items-center gap-x-1 rounded-[5px] px-1.75 py-1 sm:px-2 sm:py-1.25 text-xs bg-grey-fields-100 font-semibold inline-flex text-primary-500 flex-nowrap whitespace-nowrap",
        className
      )}
    >
      <span>
        {/* {options} {options > 1 ? "Options" : "Option"} */}
        Has Options
      </span>
    </div>
  );
};

export { DiscountBadge, OptionsBadge, DiscountBadgeImage };
